namespace $ {

	const $shm_dashboard_app_offline_blacklist = new Set([
		'//cse.google.com/adsense/search/async-ads.js',
	])

	function $shm_dashboard_app_offline_scope_url( url: string ) {
		const scope = ( self as any ).registration?.scope ?? location.href
		return new URL( url, scope )
	}

	function $shm_dashboard_app_offline_entry( request: Request ) {
		const url = $shm_dashboard_app_offline_scope_url( request.url )
		const scope = $shm_dashboard_app_offline_scope_url( './' )
		if( url.origin !== scope.origin ) return false

		const path = url.pathname.slice( scope.pathname.length )
		if( request.mode === 'navigate' ) return path === '' || path === 'index.html'
		return path === 'web.js' || path === 'index.html'
	}

	function $shm_dashboard_app_offline_enrich( response: Response ) {
		if( !response.status ) return response

		const headers = new Headers( response.headers )
		headers.set( '$mol_offline', '' )
		headers.set( 'Origin-Agent-Cluster', '?1' )

		return new Response( response.body, {
			status: response.status,
			statusText: response.statusText,
			headers,
		} )
	}

	function $shm_dashboard_app_offline_fetch( event: any, request: Request ) {
		return fetch( new Request( request, { credentials: 'omit' } ) ).then( response => {
			if( response.status !== 200 ) return response

			event.waitUntil(
				caches.open( '$mol_offline' ).then(
					cache => cache.put( request, response ),
				),
			)

			return response.clone()
		} )
	}

	function $shm_dashboard_app_offline_response( event: any, request: Request ) {
		const fresh = request.cache === 'force-cache'
			? null
			: $shm_dashboard_app_offline_fetch( event, request )

		if( $shm_dashboard_app_offline_entry( request ) ) {
			const response = fresh
				? fresh.catch( ()=> caches.match( request ).then( cached => cached ?? $shm_dashboard_app_offline_fetch( event, request ) ) )
				: caches.match( request ).then( cached => cached ?? $shm_dashboard_app_offline_fetch( event, request ) )
			return response.then( $shm_dashboard_app_offline_enrich )
		}

		if( fresh ) event.waitUntil( fresh.then( $shm_dashboard_app_offline_enrich ) )

		return caches.match( request ).then(
			cached => request.cache === 'no-cache' || request.cache === 'reload'
				? ( cached
					? fresh!
						.then( actual => {
							if( actual.status === cached.status ) return actual
							throw new Error(
								`${ actual.status }${ actual.statusText ? ` ${ actual.statusText }` : '' }`,
								{ cause: actual },
							)
						} )
						.catch( ( error: Error )=> {
							const cloned = cached.clone()
							const message = `${ error.cause instanceof Response ? '' : '500 ' }${ error.message } $mol_offline fallback to cache`
							cloned.headers.set( '$mol_offline_remote_status', message )
							return cloned
						} )
					: fresh!
				)
				: ( cached || fresh || $shm_dashboard_app_offline_fetch( event, request ) ),
		).then( $shm_dashboard_app_offline_enrich )
	}

	export function $shm_dashboard_app_offline() {

		if( typeof window === 'undefined' ) {

			self.addEventListener( 'install', ( event: any )=> {
				;( self as any ).skipWaiting()
			} )

			self.addEventListener( 'activate', ( event: any )=> {
				;( self as any ).clients.claim()

				$$.$mol_log3_done({
					place: '$shm_dashboard_app_offline',
					message: 'Activated',
				})
			} )

			self.addEventListener( 'fetch', ( event: any )=> {
				let request = event.request
				const url = $shm_dashboard_app_offline_scope_url( request.url )

				if( $shm_dashboard_app_offline_blacklist.has( request.url.replace( /^https?:/, '' ) ) ) {
					return event.respondWith( new Response( null, { status: 418, statusText: 'Blocked' } ) )
				}

				if( request.method !== 'GET' ) return
				if( !/^https?:/.test( request.url ) ) return
				if( url.origin === location.origin && /^\/login(?:\/|$)/.test( url.pathname ) ) return
				if( /\?/.test( request.url ) ) return
				if( request.cache === 'no-store' ) return
				event.respondWith( $shm_dashboard_app_offline_response( event, request ) )
			} )

			self.addEventListener( 'beforeinstallprompt', ( event: any )=> event.prompt() )

		} else if( location.protocol !== 'https:' && location.hostname !== 'localhost' ) {
			console.warn( 'HTTPS or localhost is required for service workers.' )
		} else if( !navigator.serviceWorker ) {
			console.warn( 'Service Worker is not supported.' )
		} else {
			$mol_dom.addEventListener( 'DOMContentLoaded', ()=> {
				navigator.serviceWorker.register( 'web.js' ).then( reg => {
					reg.addEventListener( 'updatefound', ()=> {
						$$.$mol_log3_rise({
							place: '$shm_dashboard_app_offline',
							message: 'Outdated',
						})

						const worker = reg.installing!
						worker.addEventListener( 'statechange', ()=> {
							if( worker.state !== 'activated' ) return
							window.location.reload()
						} )
					} )
				} ).catch( error => console.warn( error ) )
			} )
		}
	}

	$.$mol_offline = $shm_dashboard_app_offline

	try {
		$.$mol_offline()
	} catch( error ) {
		console.error( error )
	}

}
